<!-- 积分日志查询 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap"> 
        <el-form :model="searchForm" ref="searchForm" :inline="true"> 
            <el-form-item label="会员姓名">
                <el-input v-model="searchForm.username" placeholder="请输入会员姓名"></el-input>
            </el-form-item>
            <el-form-item label="会员角色">
                <el-select v-model="searchForm.roleId" style="width: 200px;">
                    <el-option 
                        v-for="item in roleOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>               
                <!-- <el-button @click="resetForm('searchForm')">重置</el-button> -->
            </el-form-item>        
        </el-form>
        <el-table border :data="tableData">
            <el-table-column  prop="index"   label="流水号"   width="100" />
            <el-table-column  prop="username"  label="会员姓名"  width="180"/>
            <el-table-column  prop="phone"  label="手机号"  width="180"/>
            <el-table-column  prop="title"  label="赛事主题"  width="180"/>      
            <el-table-column  prop="grade"  label="积分"/>
            <el-table-column  prop="date"  label="日期"/>
            <el-table-column  prop="opreator"  label="操作人"/>
        </el-table>  
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="getQuery"
        /> 
    </div>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
export default {
    components:{
        PageBack,
        pagination
    },
    data() {
        return {
            searchForm:{
                userId: '',
                username: '',
                title: '',
                roleId: 1,
                startDate: 0,
                endDate: 0,
            },
            roleOption: [
                {label:'全部', value:''},
                {label:'选手', value:1},
                {label:'教练', value:2},
                {label:'裁判', value:3},
                {label:'协会/俱乐部', value:4},
            ],
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [], 
            total: 0,
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }, 
    },
    created() {

    },
    mounted() {
        this.getQuery()
    },
    methods: {
        getQuery(){
            let params = {
                opcode: this.$code.GradeLog,
                i_client_no: this.searchForm.userId,
                v_name: this.searchForm.username,
                v_theme: this.searchForm.title,
                c_type: this.searchForm.roleId,
                start_date: this.searchForm.startDate,
                end_date: this.searchForm.endDate,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,                
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.total = res.Data.SumCount
                    if(result.length > 0){
                        this.tableData = result.map(item=>{
                            let direction = item['方向']
                            let sign = direction === '加'? '+': '-'
                            let grade = item['积分'] === 0 ? item['积分'] : sign +''+ item['积分']
                            return{
                                index: item['流水号'],
                                serial: item['赛事标识'],
                                title: item['赛事主题'],
                                grade: grade,
                                phone: item['手机号'],
                                username: item['客户姓名'],
                                userId: item['客户编号'],
                                opreator: item['操作人'],
                                date: this.$help.formatDate(item['日期'])+' '+ this.$help.formatTime(item['时间']),
                            }
                        })
                    }else{
                        this.tableData = []
                    }
                }
            })
        },
        searchQuery(){
            this.getQuery()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.startDate = 0
            this.endDate = 0
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/admin/integralLog.vue